// extracted by mini-css-extract-plugin
module.exports = {"steps":"steps-module--steps--28UdY","itemStep":"steps-module--item-step--dnEr3","numberStep":"steps-module--number-step--3fErI"};